export const validatePassword = (password) => {
   let errorMessage = '';

   const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;

   if (!passwordPattern.test(password)) {
      errorMessage = 'Password must be at least 8 characters, 1 uppercase, and 1 number.';
   }

   return errorMessage;
};

export const confirmPassword = (newpassword, value) => {
   let errorMessage = '';

   if (newpassword !== value) {
      errorMessage = 'Passwords do not match.';
   }

   return errorMessage;
};
